import React from 'react';
import Icon from '../../components/Icon';

const COLORS = ['gray', 'danger', 'danger', 'orange', 'warning', 'success'];

const LessonImportance = ({stars}) => {
  return (
    <div className="row gx-1 justify-content-center mb-1">
      {stars > 0 && (
        <div className="col-auto">
          <Icon name="star" color={COLORS[stars]} />
        </div>
      )}
      {stars > 1 && (
        <div className="col-auto">
          <Icon name="star" color={COLORS[stars]} />
        </div>
      )}
      {stars > 2 && (
        <div className="col-auto">
          <Icon name="star" color={COLORS[stars]} />
        </div>
      )}
      {stars > 3 && (
        <div className="col-auto">
          <Icon name="star" color={COLORS[stars]} />
        </div>
      )}
      {stars > 4 && (
        <div className="col-auto">
          <Icon name="star" color={COLORS[stars]} />
        </div>
      )}
    </div>
  );
};

export default LessonImportance;
